import { BlobWithHeaders } from '@cbridge-packages/api-base';

export const downloadFileFromResponse = (response: BlobWithHeaders) => {
  const { data: blob, headers } = response;
  const disposition = headers['content-disposition'];

  let filename = 'export.csv';

  if (disposition?.includes('filename=')) {
    const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
    if (filenameMatch?.[1]) {
      filename = filenameMatch[1];
    }
  }

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
